import { render } from "./examinationPaperDownload.vue?vue&type=template&id=b7cfa2a6&scoped=true"
import script from "./examinationPaperDownload.vue?vue&type=script&lang=js"
export * from "./examinationPaperDownload.vue?vue&type=script&lang=js"

import "./examinationPaperDownload.vue?vue&type=style&index=0&id=b7cfa2a6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7cfa2a6"]])

export default __exports__